import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThreddPatternHeading = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 8 16",
	...props,
	children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", { d: "M0 0h8v16H0z" })
	}), /* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#a)",
		children: [/* @__PURE__ */ _jsx("path", {
			fill: "#0d058f",
			d: "M0 0h8v16H0z"
		}), /* @__PURE__ */ _jsxs("g", {
			fill: "#17d4ff",
			children: [
				/* @__PURE__ */ _jsx("path", { d: "M0 1.147h2v1.146H0zm2 0h2v1.146H2zM2 0h2v1.146H2z" }),
				/* @__PURE__ */ _jsx("path", { d: "M0 2.292h2v1.146H0zm0 3.443h2V6.88H0zm2 0h2V6.88H2zm0-1.147h2v1.146H2zM0 6.88h2v1.146H0zm0 3.437h2v1.147H0zm2 0h2v1.147H2zM2 9.17h2v1.147H2z" }),
				/* @__PURE__ */ _jsx("path", { d: "M0 11.462h2v1.146H0zm0 3.446h2v1.146H0zm2 0h2v1.146H2zm0-1.148h2v1.147H2zM4 2.147h2v1.146H4zm2 0h2v1.146H6zM6 1h2v1.146H6z" }),
				/* @__PURE__ */ _jsx("path", { d: "M4 3.292h2v1.146H4zm0 3.443h2V7.88H4zm2 0h2V7.88H6zm0-1.147h2v1.146H6zM4 7.88h2v1.146H4zm0 3.437h2v1.147H4zm2 0h2v1.147H6zm0-1.147h2v1.147H6z" }),
				/* @__PURE__ */ _jsx("path", { d: "M4 12.462h2v1.146H4zm0 3.446h2v1.146H4zm2 0h2v1.146H6zm0-1.148h2v1.147H6z" })
			]
		})]
	})]
});
export default SvgThreddPatternHeading;
